import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-bp.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-bp.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationService } from "../../../view-application.service";
import { Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ViewApplicationDetailsBpConstants } from "./view-application-details-bp.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../../app-controller.service";
import { ViewApplicationProfessionalBodiesWConstants } from "../../w/view-application-professional-bodies-w/view-application-professional-bodies-w.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { take, takeUntil } from "rxjs/operators";
let ViewApplicationDetailsBpComponent = class ViewApplicationDetailsBpComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    appController;
    viewApplicationService;
    changeDetectorRefs;
    detailsForm;
    validationMessages = ViewApplicationDetailsBpConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    sectorOptionsLookupName = ViewApplicationDetailsBpConstants.SECTOR_OPTION_LOOKUP_NAME;
    buildingUseOptionsLookupName = ViewApplicationDetailsBpConstants.BUILDING_USE_OPTION_LOOKUP_NAME;
    nonResidentialBuildingUseLookupName = ViewApplicationDetailsBpConstants.NON_RESIDENTIAL_BUILDING_USE_OPTION_LOOKUP_NAME;
    residentialBuildingUseLookupName = ViewApplicationDetailsBpConstants.RESIDENTIAL_BUILDING_USE_OPTION_LOOKUP_NAME;
    typeOptionsLookupName = ViewApplicationDetailsBpConstants.TYPE_OPTION_LOOKUP_NAME;
    estimatedByOptionsLookupName = ViewApplicationDetailsBpConstants.ESTIMATED_BY_OPTION_LOOKUP_NAME;
    saveBtnPlaceholder = ViewApplicationDetailsBpConstants.SAVE_BUTTON_PLACEHOLDER;
    descriptionLabel = ViewApplicationDetailsBpConstants.DESCRIPTION_LABEL;
    isMinorBuildingWorkLabel = ViewApplicationDetailsBpConstants.IS_MINOR_BUILDING_WORK_LABEL;
    isResidentialApplicationLabel = ViewApplicationDetailsBpConstants.IS_RESIDENTIAL_APPLICATION_LABEL;
    sectorLabel = ViewApplicationDetailsBpConstants.SECTOR_LABEL;
    isRDPLabel = ViewApplicationDetailsBpConstants.IS_RDP_LABEL;
    buildingUseLabel = ViewApplicationDetailsBpConstants.BUILDING_USE_LABEL;
    otherBuildingUseLabel = ViewApplicationDetailsBpConstants.OTHER_BUILDING_USE_LABEL;
    isAlterationsLabel = ViewApplicationDetailsBpConstants.IS_ALTERATIONS_LABEL;
    referenceNumberLabel = ViewApplicationDetailsBpConstants.REFERENCE_NUMBER_LABEL;
    buildingPlanNumberLabel = ViewApplicationDetailsBpConstants.BUILDING_PLAN_NUMBER_LABEL;
    typeLabel = ViewApplicationDetailsBpConstants.APPLICATION_TYPE_LABEL;
    estimatedByLabel = ViewApplicationDetailsBpConstants.APPLICATION_ESTIMATED_BY_LABEL;
    estimatedCostLabel = ViewApplicationDetailsBpConstants.APPLICATION_ESTIMATED_COST_LABEL;
    previousReferenceNumberLabel = ViewApplicationDetailsBpConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isResubmissionLabel = ViewApplicationDetailsBpConstants.IS_RESUBMISSION_LABEL;
    descriptionFormControlName = ViewApplicationDetailsBpConstants.DESCRIPTION_FORM_CONTROL_NAME;
    isMinorBuildingWorkFormControlName = ViewApplicationDetailsBpConstants.IS_MINOR_BUILDING_WORK_FORM_CONTROL_NAME;
    isResidentialApplicationFormControlName = ViewApplicationDetailsBpConstants.IS_RESIDENTIAL_APPLICATION_CONTROL_NAME;
    isAlterationsFormControlName = ViewApplicationDetailsBpConstants.IS_ALTERATIONS_CONTROL_NAME;
    isBuildingUseOtherFormControlName = ViewApplicationDetailsBpConstants.IS_BUILDING_USE_OTHER_CONTROL_NAME;
    buildingTypeFormControlName = ViewApplicationDetailsBpConstants.BUILDING_TYPE_CONTROL_NAME;
    sectorFormControlName = ViewApplicationDetailsBpConstants.SECTOR_FORM_CONTROL_NAME;
    isRDPFormControlName = ViewApplicationDetailsBpConstants.IS_RDP_FORM_CONTROL_NAME;
    buildingUseFormControlName = ViewApplicationDetailsBpConstants.BUILDING_USE_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsBpConstants.REFERENCE_NUMBER_FORM_CONTROL_NAME;
    typeFormControlName = ViewApplicationDetailsBpConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    estimatedByFormControlName = ViewApplicationDetailsBpConstants.APPLICATION_ESTIMATED_BY_FORM_CONTROL_NAME;
    estimatedCostFormControlName = ViewApplicationDetailsBpConstants.APPLICATION_ESTIMATED_COST_FORM_CONTROL_NAME;
    previousReferenceNumberFormControlName = ViewApplicationDetailsBpConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    isResubmissionFormControlName = ViewApplicationDetailsBpConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    buildingPlanNumberControlName = ViewApplicationDetailsBpConstants.BUILDING_PLAN_NUMBER_FORM_CONTROL_NAME;
    yesNoOptions = [];
    sectorOptions = [];
    buildingUseOptions = [];
    applicationTypeOptions = [];
    nonResidentialBuildingUseOptions = [];
    residentialBuildingUseOptions = [];
    buildingUseLegacyOptions = [];
    estimatedByOptions = [];
    application;
    getApplicationSaveObservableSubscription;
    getStepMetaObservableSubscription;
    getLookupsObservableSubscription;
    supportResubmissions = false;
    isResubmission = false;
    showBuildingTypeField = false;
    constructor(aflaModuleStrategyService, route, routerParamsService, appController, viewApplicationService, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.viewApplicationService = viewApplicationService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
        if (this.appController.moduleAllowResubmission) {
            this.supportResubmissions = true;
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    handleRouteChange() {
        // this.getMetadata();
    }
    onBtnSaveClicked() {
        if (this.detailsForm.valid) {
            const app = {
                isMinorBuildingWork: this.detailsForm.get(this.isMinorBuildingWorkFormControlName).value,
                isResidential: this.detailsForm.get(this.isResidentialApplicationFormControlName).value,
                buildingUse: this.detailsForm.get(this.buildingUseFormControlName).value,
                isAlterations: this.detailsForm.get(this.isAlterationsFormControlName).value,
                isBuildingUseOther: this.detailsForm.get(this.isBuildingUseOtherFormControlName).value,
                buildingType: this.detailsForm.get(this.buildingTypeFormControlName).value,
                isRdp: this.detailsForm.get(this.isRDPFormControlName).value,
                sector: this.detailsForm.get(this.sectorFormControlName).value.value,
                applicationType: this.detailsForm.get("applicationType").value.value,
                applicationEstimatedBy: this.detailsForm.get(this.estimatedByFormControlName).value.value,
                applicationEstimatedCost: this.detailsForm.get(this.estimatedCostFormControlName).value,
                isResubmission: this.detailsForm.get(this.isResubmissionFormControlName).value,
                previousReferenceNumber: this.detailsForm.get(this.previousReferenceNumberFormControlName).value,
            };
            this.getApplicationSaveObservableSubscription =
                this.viewApplicationService.getApplicationSaveObservable(this.aflaModuleStrategyService.applicationServiceUrl, this.application.id, app)
                    .subscribe({ next: () => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        this.getApplication();
                    }, error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationDetailsBpConstants.STEP_TITLE, error, CRUDOperation.Update);
                    } });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getApplication() {
        const params = {
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationProfessionalBodiesWConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        this.getLookups();
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID} and (name eq 'ResidentialBuildingUse' or name eq 'NonResidentialBuildingUse' or name eq 'BuildingSector' or name eq 'ApplicationType' or name eq 'PropertyEstimatedBy' or name eq 'BuildingUse' and deleted eq false)`,
        };
        this.getLookupsObservableSubscription = this.viewApplicationService.getLookupsObservable(params).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsBpConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const buildingUseLegacy = [];
        const nonResidentialBuildingUse = [];
        const residentialBuildingUse = [];
        const sector = [];
        const applicationType = [];
        const estimatedBy = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "NonResidentialBuildingUse") {
                    nonResidentialBuildingUse.push(JSON.parse(item.content));
                }
                if (item.name === "ResidentialBuildingUse") {
                    residentialBuildingUse.push(JSON.parse(item.content));
                }
                if (item.name === "BuildingSector") {
                    sector.push(JSON.parse(item.content));
                }
                if (item.name === "ApplicationType") {
                    applicationType.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyEstimatedBy") {
                    estimatedBy.push(JSON.parse(item.content));
                }
                if (item.name === "BuildingUse") {
                    buildingUseLegacy.push(JSON.parse(item.content));
                }
            });
        }
        nonResidentialBuildingUse.sort((a, b) => a.value.localeCompare(b.value));
        residentialBuildingUse.sort((a, b) => a.value.localeCompare(b.value));
        sector.sort((a, b) => a.value.localeCompare(b.value));
        applicationType.sort((a, b) => a.value.localeCompare(b.value));
        estimatedBy.sort((a, b) => a.value.localeCompare(b.value));
        buildingUseLegacy.sort((a, b) => a.value.localeCompare(b.value));
        this.yesNoOptions = [];
        this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
        this.nonResidentialBuildingUseOptions = nonResidentialBuildingUse;
        this.residentialBuildingUseOptions = residentialBuildingUse;
        // this.buildingUseLegacyOptions = buildingUseLegacy;
        this.sectorOptions = sector;
        this.applicationTypeOptions = applicationType;
        this.estimatedByOptions = estimatedBy;
        this.getApplication();
        this.changeDetectorRefs.detectChanges();
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.application = response.value[0];
            this.detailsForm.get(this.descriptionFormControlName).setValue(this.application.description);
            this.detailsForm.get(this.buildingPlanNumberControlName).setValue(this.application.buildingPlanNumber);
            this.detailsForm.get(this.referenceNumberControlName).setValue(this.application.referenceNumber);
            this.detailsForm.get(this.isMinorBuildingWorkFormControlName).setValue(this.application.isMinorBuildingWork);
            this.detailsForm.get(this.buildingTypeFormControlName).setValue(this.application.buildingType);
            this.detailsForm.get(this.isAlterationsFormControlName).setValue(this.application.isAlterations);
            if (this.application.isAlterations) {
                if (this.application.isResidential?.toLowerCase().trim() === "yes") {
                    this.getBuildingUseFromResidentialBuildingUse();
                }
                if (this.application.isResidential?.toLowerCase().trim() === "no") {
                    this.nonResidentialApplicationSelected();
                }
            }
            else {
                this.buildingUseOptions = [];
                const legacyBuildingUseValue = this.application.buildingUse;
                this.buildingUseOptions.push({ code: legacyBuildingUseValue, value: legacyBuildingUseValue });
                this.showBuildingTypeField = false;
            }
            this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(this.application.isBuildingUseOther);
            if (this.application.isBuildingUseOther) {
                this.showBuildingTypeField = true;
            }
            this.detailsForm.get(this.isResidentialApplicationFormControlName).setValue(this.application.isResidential);
            // this.detailsForm.get(this.buildingUseFormControlName).setValue(this.application.buildingUse);
            this.detailsForm.get(this.isRDPFormControlName).setValue(this.application.isRdp);
            this.detailsForm.get(this.estimatedCostFormControlName).setValue(this.application.applicationEstimatedCost);
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(this.application.isResubmission);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(this.application.previousReferenceNumber);
            if (this.application.isResubmission) {
                this.isResubmission = this.application.isResubmission;
            }
            this.sectorOptions.forEach(item => {
                if (item.value === this.application.sector) {
                    this.detailsForm.get("sector").setValue(item);
                }
            });
            this.buildingUseOptions.forEach(item => {
                if (item.value === this.application.buildingUse) {
                    this.detailsForm.get("buildingUse").setValue(item.value);
                }
            });
            this.applicationTypeOptions.forEach(item => {
                if (item.value === this.application.applicationType) {
                    this.detailsForm.get("applicationType").setValue(item);
                }
            });
            this.estimatedByOptions.forEach(item => {
                if (item.value === this.application.applicationEstimatedBy) {
                    this.detailsForm.get("applicationEstimatedBy").setValue(item.value);
                }
            });
            this.detailsForm.get("description").disable();
            this.detailsForm.get("referenceNumber").disable();
            this.detailsForm.get("isResubmission").disable();
            this.detailsForm.get("previousReferenceNumber").disable();
            this.detailsForm.updateValueAndValidity();
            this.changeDetectorRefs.detectChanges();
        }
    }
    onIsResubmissionChecked(event) {
        const element = event.target.checked;
        this.isResubmission = element;
        this.detailsForm.get(this.isResubmissionFormControlName).setValue(element);
        if (this.isResubmission) {
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).enable();
        }
        else {
            this.detailsForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).disable();
        }
        this.detailsForm.get(this.previousReferenceNumberFormControlName).updateValueAndValidity();
        this.detailsForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    buildingUSeChanged($event) {
        const buildingUseValue = $event.target.value;
        if (buildingUseValue?.toLowerCase().trim() === "other") {
            this.otherApplicationIsSelected();
        }
        this.changeDetectorRefs.detectChanges();
    }
    otherApplicationIsSelected() {
        // this.detailsForm.addControl(this.buildingTypeFormControlName, new FormControl(null, Validators.required));
        this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(true);
        this.detailsForm.updateValueAndValidity();
        this.showBuildingTypeField = true;
    }
    isResidentialChanged($event) {
        const isResidential = $event.target.value;
        if (isResidential?.toLowerCase().trim() === "yes") {
            this.getBuildingUseFromResidentialBuildingUse();
        }
        if (isResidential?.toLowerCase().trim() === "no") {
            this.nonResidentialApplicationSelected();
        }
    }
    getBuildingUseFromResidentialBuildingUse() {
        this.buildingUseOptions = [];
        this.buildingUseOptions = this.residentialBuildingUseOptions;
        this.aflaModuleStrategyService.lookups.set(this.buildingUseOptionsLookupName, this.buildingUseOptions);
        this.showBuildingTypeField = false;
        // this.detailsForm.removeControl(this.buildingTypeFormControlName);
        this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(false);
        this.detailsForm.updateValueAndValidity();
    }
    nonResidentialApplicationSelected() {
        this.buildingUseOptions = [];
        this.buildingUseOptions = this.nonResidentialBuildingUseOptions;
        this.aflaModuleStrategyService.lookups.set(this.buildingUseOptionsLookupName, this.buildingUseOptions);
        this.showBuildingTypeField = false;
        // this.detailsForm.removeControl(this.buildingTypeFormControlName);
        this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(false);
        this.detailsForm.updateValueAndValidity();
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ViewApplicationService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsBpComponent = __decorate([
    Component({
        selector: "app-view-application-details-bp",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsBpComponent);
export { ViewApplicationDetailsBpComponent };
